"use client";

import { ChevronRight } from "lucide-react";

import { Button } from "@repo/ui/components/ui/button";

interface HelpButtonProps {
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
}

export const HelpCard = ({ icon, label, onClick }: HelpButtonProps) => (
  <Button
    variant="outline"
    className="h-auto w-full items-center justify-between rounded-lg border-slate-300 bg-gray-50 px-4 py-3 text-left"
    onClick={onClick}
  >
    <div className="flex flex-1 items-center space-x-2">
      {icon}
      <span className="leading-snug font-medium break-words whitespace-normal">{label}</span>
    </div>
    <ChevronRight className="h-5 w-5" />
  </Button>
);
